module.exports = __webpack_public_path__ + "static/media/camcorder.b2ddcbd0.svg";